import React, { useEffect, useCallback } from 'react'
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

//Funcion para mostrar el Backdrop con el Spinner Circular.
function CargaSpinner({ contadorSpinner }) {
    const [open, setOpen] = React.useState(false);

    const mostrarError = useCallback(() => {//
        setOpen(contadorSpinner);
    }, [contadorSpinner]);

    //Si se modifica el contador se carga el spinner
    useEffect(() => {
        mostrarError();
    }, [contadorSpinner])
    return (
        <div>
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={open}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </div>
    );
}

export default CargaSpinner;